import React from "react";
import { SpeedoMeter as SpeedoMeterWebComponent } from "react-library";
import { Link } from "react-router-dom";
import { t, TLang } from "../../../services/locale.service";
import { Routes } from "../../../routes";

type Props = {
  highlights: THighlights,
  value: number,
  majorTicks: Array<string>,
  valueStatus: string,
  valueStatusColor?: string,
  unit?: string,
  sensorName?: string,
  speedoMeterSize?: number,
  language?: TLang,
  plotId: string,
  sensor: string,
  isDisease?: boolean,
  isPest?: boolean,
  isApplicable?: boolean
}

export type THighlight = {
  from: number;
  to: number;
  color: string;
}

export type THighlights = Array<THighlight>;

const SpeedoMeter: React.FC<Props> = (props) => {

  const { plotId, sensor, ...speedoMeterProps } = props;

  const chartUrl = Routes.plotChart
    .replace(":plotId", plotId)
    .replace(":sensor", sensor);

  return (
    <Link 
      to={chartUrl} 
      state={{ 
        sensorName: speedoMeterProps.sensorName, 
        isDisease: Boolean(speedoMeterProps.isDisease),
        isPest: Boolean(speedoMeterProps.isPest)
      }} 
      className="text-decoration-none"
    >
      <SpeedoMeterWebComponent {...speedoMeterProps} additionalInfo={speedoMeterProps.isApplicable!==undefined && !speedoMeterProps.isApplicable?t("notApplicable"): ""}/>
    </Link>
  );
};

export default SpeedoMeter;